import { get, handleClientError } from "../lib"

export interface ResponseType {
    enabled: boolean,
    url:string
}

export const getDataspyStatus = async ():Promise<ResponseType> => {
    try{
        const response =  await get<ResponseType>({
            path: '/api/v1/data/dataspyStatus',
        })
        
        if(response != null && typeof response == 'object'){
            return response
        }
        else{
            return {
                enabled: false,
                url: ''
            }
        }
        
    } catch (e: any) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        throw handleClientError(e)
    }
}
